

export default class Navigation {

  constructor({ selector, scroller }) {
    this.selector = selector instanceof window.HTMLElement ? selector : document.querySelector(selector)
    this.links = document.querySelectorAll(selector + ' a')
    this.scroller = scroller
    //Methode    
    this.createListener()
  }

  createListener() {
    this.links.forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault()

        // console.log(e.target.hash)
        //Locomotive scroller
        // this.scroller.scrollTo(document.querySelector(e.target.hash));
        
        //Lenis Scroller
        // this.scroller.scrollTo(e.target.hash, {offset, immediate, duration, easing})
        this.scroller.scrollTo(e.target.hash,{
          duration :3, 
          immediate : false,          
          easing : (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t))
        })

      })
    });

  }
}